import { SelectOption } from '@act/storybook';

export const visitDurations: SelectOption<number>[] = [
  {
    label: '5 m',
    value: 5,
  },
  {
    label: '10 m',
    value: 10,
  },
  {
    label: '15 m',
    value: 15,
  },
  {
    label: '30 m',
    value: 30,
  },
  {
    label: '45 m',
    value: 45,
  },
  {
    label: '1 h',
    value: 60,
  },
  {
    label: '1 h, 15 m',
    value: 60 + 15,
  },
  {
    label: '1 h, 30 m',
    value: 60 + 30,
  },
  {
    label: '1 h, 45 m',
    value: 60 + 45,
  },
  {
    label: '2 h',
    value: 2 * 60,
  },
  {
    label: '2 h, 30 m',
    value: 2.5 * 60,
  },
  {
    label: '3 h',
    value: 3 * 60,
  },
  {
    label: '4 h',
    value: 4 * 60,
  },
  {
    label: '5 h',
    value: 5 * 60,
  },
  {
    label: '6 h',
    value: 6 * 60,
  },
].map(option => ({
  label: option.label,
  value: option.value * 60 * 1000, // minutes to milliseconds
}));
